module.exports = __webpack_public_path__ + "static/media/injection.de4c219a.png";